var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1055_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.65548 6.43408H0.640452C0.462258 6.43408 0.317871 6.57853 0.317871 6.75666V19.6552C0.317871 19.8334 0.462258 19.9778 0.640452 19.9778H4.65548C4.83368 19.9778 4.97807 19.8334 4.97807 19.6552V6.75666C4.97807 6.57853 4.83368 6.43408 4.65548 6.43408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64942 0.0219727C1.18852 0.0219727 0 1.2092 0 2.66849C0 4.12842 1.18852 5.3161 2.64942 5.3161C4.10916 5.3161 5.29671 4.12836 5.29671 2.66849C5.29677 1.2092 4.10916 0.0219727 2.64942 0.0219727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.868 6.11377C13.2555 6.11377 12.0634 6.807 11.3404 7.59467V6.75693C11.3404 6.5788 11.196 6.43435 11.0178 6.43435H7.17268C6.99448 6.43435 6.8501 6.5788 6.8501 6.75693V19.6555C6.8501 19.8337 6.99448 19.9781 7.17268 19.9781H11.1789C11.3571 19.9781 11.5015 19.8337 11.5015 19.6555V13.2737C11.5015 11.1232 12.0856 10.2854 13.5847 10.2854C15.2174 10.2854 15.3471 11.6285 15.3471 13.3843V19.6556C15.3471 19.8338 15.4915 19.9782 15.6697 19.9782H19.6775C19.8556 19.9782 20 19.8338 20 19.6556V12.5805C20 9.38274 19.3903 6.11377 14.868 6.11377Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1055_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.763d5e0047c48b0b1c5fa8da32199bc8.svg";
export { ForwardRef as ReactComponent };